var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconIllustrativeLogin = function IconIllustrativeLogin(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8 8.2C50.024 2.302 41.012.06 32 0 22.989.061 13.978 2.303 8.2 8.2 2.301 13.977.06 22.988 0 32c.061 9.011 2.303 18.023 8.2 23.8C13.976 61.699 22.988 63.94 32 64c9.011-.061 18.022-2.302 23.8-8.2C61.698 50.023 63.94 41.012 64 32c-.061-9.011-2.303-18.023-8.2-23.8",
    fill: "#007FF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.767 52.192a22.244 22.244 0 01-2.967 3.609C50.023 61.698 41.011 63.939 32 64c-9.011-.061-18.023-2.302-23.8-8.2a22.374 22.374 0 01-3.193-3.956c5.81-1.937 15.464-3.204 26.388-3.204 11.566 0 21.707 1.42 27.372 3.552z",
    fill: "#003B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.52 28.8c0 6.362-5.158 11.52-11.52 11.52-6.364 0-11.52-5.158-11.52-11.52 0-6.361 5.156-11.52 11.52-11.52 6.362 0 11.52 5.159 11.52 11.52z",
    fill: "#FFB500"
  }));
};

IconIllustrativeLogin.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconIllustrativeLogin;
//# sourceMappingURL=IconIllustrativeLogin.js.map